import React, {useState} from 'react';
import {toast} from 'react-toastify';
import {Button, Input} from 'reactstrap';
import {getRssPreviewForEntity} from 'utils/api';
import SpinnerButton from 'components/SpinnerButton';

const AddRssSourceInput = ({activeEntityId, addSourceToEntity}) => {
    const [fetchingContent, setFetchingContent] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const fetchRssContent = async() => {
        try {
            setFetchingContent(true);
            const params = {
                url: inputValue && inputValue.trim(),
                entityId: activeEntityId,
            };
            let data = await getRssPreviewForEntity(params);
            addSourceToEntity(data.content, 'rss');
            setInputValue('');
            toast.info('Source successfully added');
            setFetchingContent(false);
        } catch(e) {
            setFetchingContent(false);
            if(e.message && e.message.length < 150) {
                toast.error(e.message);
                throw e.message;
            }
        }
    };

    const handleSearchChange = (e) => {
        if(e.key === 'Enter') {
            if(e.target.value.trim()) {
                fetchRssContent();
            }
        } else {
            handleInputChange(e.target.value);
        }
    };

    const handleInputChange = (value) => {
        setInputValue(value);
    };

    return (
        <div className="w-100">
            <div className="d-flex">
                <div className="w-100 d-flex">
                    <div className="d-flex justify-content-between w-100">
                        <div className="position-relative w-100">
                            <i className="fas fa-rss add-entity-source-input-icon" style={{color: '#ee802f'}}/>
                            <Input
                                onKeyPress={(e) => handleSearchChange(e)}
                                onChange={(e) => handleSearchChange(e)}
                                value={inputValue}
                                placeholder="Enter the RSS feed URL"
                                type="text"
                                className="create-fetch_input"
                                style={{padding: '0 35px'}}
                                autoComplete="off"
                            />
                            {inputValue && inputValue.trim() && (
                                <i
                                    onClick={() => handleInputChange('')}
                                    className="fa fa-times-circle"
                                    style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        right: '0',
                                        top: '0',
                                        padding: '10.5px',
                                    }}
                                />
                            )}
                        </div>
                        {/*<Button*/}
                        {/*    className="calltoaction-button"*/}
                        {/*    style={{marginLeft: '10px', lineHeight: '0', minWidth: '75px'}}*/}
                        {/*    onClick={fetchRssContent}*/}
                        {/*    disabled={!inputValue.trim() || fetchingContent}*/}
                        {/*>*/}
                        {/*    {fetchingContent ?*/}
                        {/*        <div className="flex-centered">*/}
                        {/*            <i className="fa fa-spinner fa-spin"/>*/}
                        {/*        </div>*/}
                        {/*        :*/}
                        {/*        <React.Fragment>*/}
                        {/*            <span style={{fontSize: '14px '}}><i style={{display: 'inline'}}*/}
                        {/*                                                 className="fas fa-plus"/></span>&nbsp;*/}
                        {/*            <span style={{fontSize: '16px'}}>Add</span>*/}
                        {/*        </React.Fragment>*/}
                        {/*    }*/}
                        {/*</Button>*/}
                        <div style={{marginLeft: '10px'}}>
                            <SpinnerButton
                                minWidth="75px"
                                title="Add"
                                iconClass="fas fa-plus"
                                submitting={fetchingContent}
                                onClick={fetchRssContent}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddRssSourceInput;
